/**
 * Removes the static `<!--SEO_HEAD_START-->…<!--SEO_HEAD_END-->` block from
 * <head>.
 *
 * That block is the no-JS / crawler fallback: it holds default SEO tags in
 * index.html and is replaced per-page/per-language by the Vercel edge
 * middleware for crawlers. On a JS client it is redundant — React 19 +
 * MetadataRenderer render the authoritative per-page <title>/<meta>/<link>.
 * Leaving the static block in place would duplicate tags (two <title>s, two
 * canonicals, …) and Google would read whichever comes first.
 *
 * MUST run BEFORE React's first render (called from main.tsx) so React starts
 * from a clean <head> and there is exactly one of each tag afterwards. Running
 * it after mount is unreliable because React 19 adopts/append-manages the
 * existing <title> node.
 */
export const stripStaticSeoHead = (): void => {
  if (typeof document === 'undefined' || !document.head) return;
  let inBlock = false;
  for (const node of Array.from(document.head.childNodes)) {
    if (node.nodeType === Node.COMMENT_NODE) {
      const text = node.textContent ?? '';
      if (text.includes('SEO_HEAD_START')) {
        inBlock = true;
        node.remove();
        continue;
      }
      if (text.includes('SEO_HEAD_END')) {
        inBlock = false;
        node.remove();
        continue;
      }
    }
    if (inBlock) node.remove();
  }
};
